import React from 'react';
interface IntegratedLogoProps {
  className?: string;
  size?: number;
}
export const IntegratedLogo = ({
  className = '',
  size = 90
}: IntegratedLogoProps) => {
  return <div className={`relative inline-flex items-center justify-center flex-shrink-0 ${className}`} style={{
    width: size,
    height: size
  }} data-id="element-307">
      {/* Subtle warm halo */}
      <div className="absolute inset-0 pointer-events-none" style={{
      background: 'radial-gradient(circle at center, rgba(245, 235, 215, 0.4) 0%, rgba(245, 235, 215, 0.12) 50%, transparent 70%)',
      filter: 'blur(10px)',
      transform: 'scale(1.2)'
    }} data-id="element-308" />

      {/* Use object-cover + square container so the central SB circle fills the visible
              area completely. The radial mask is then perfectly aligned with the SB design. */}
      <div className="relative z-10 w-full h-full overflow-hidden" style={{
      WebkitMaskImage: `radial-gradient(
            circle at center,
            black 0%,
            black 40%,
            rgba(0,0,0,0.96) 46%,
            rgba(0,0,0,0.82) 50%,
            rgba(0,0,0,0.58) 54%,
            rgba(0,0,0,0.32) 58%,
            rgba(0,0,0,0.12) 62%,
            transparent 68%
          )`,
      maskImage: `radial-gradient(
            circle at center,
            black 0%,
            black 40%,
            rgba(0,0,0,0.96) 46%,
            rgba(0,0,0,0.82) 50%,
            rgba(0,0,0,0.58) 54%,
            rgba(0,0,0,0.32) 58%,
            rgba(0,0,0,0.12) 62%,
            transparent 68%
          )`
    }} data-id="element-309">
        <img src="https://cdn.magicpatterns.com/uploads/ih8N4xKcHh3EmEz85NHz92/LOGO_STEF_ALISADOS.png" alt="Alisados Stefania Becerra" className="w-full h-full object-cover" style={{
        objectPosition: 'center center'
      }} data-id="element-310" />
      </div>
    </div>;
};